document.addEventListener('DOMContentLoaded', function() {
  const generateCouponBtn = document.querySelector('.mc-modal-confirm');
  const modal = document.getElementById('mc-coupon-modal');
  const modalBody = document.getElementById('mc-modal-body');
  const noticeContainer = document.getElementById('mc-notice');
  const noticeText = document.getElementById('mc-notice-text');
  const discountBtn = document.getElementById('mc-discount-btn');
  const couponsContainer = document.getElementById('mc-coupons');
  const couponList = document.getElementById('mc-coupon-list');
  const noData = document.getElementById('mc-no-data');
  const customerId = modal.getAttribute('data-customer-id');
  const apiBaseUrl = 'https://loyalti.magecomp.org/api';

  async function fetchCustomerPoints() {
    try {
      const response = await fetch(`${apiBaseUrl}/get-customer-points`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({
          userId: customerId,
          shop: Shopify.shop,
        }),
      });

      const data = await response.json();
      if (!response.ok || !data.success) {
        throw new Error(data.message || 'Failed to fetch customer points');
      }

      const { points, hold_points, redeem_points, coupon_min_amt, coupon_codes } = data.points_data;
      const netPoints = points - hold_points;
      const needPoints = 1000 - netPoints;

      document.getElementById('available-points').textContent = netPoints;
      document.getElementById('hold-points').textContent = hold_points;
      document.getElementById('redeemed-points').textContent = redeem_points;
      
      const badgeElement = document.getElementById('customer-badge');
      let badgeText = 'Basic';
      let badgeClass = 'basic';

      if (points >= 10000) {
        badgeText = 'Platinum';
        badgeClass = 'platinum';
      } else if (points >= 5000) {
        badgeText = 'Gold';
        badgeClass = 'gold';
      } else if (points >= 1000) {
        badgeText = 'Silver';
        badgeClass = 'silver';
      }

      badgeElement.textContent = badgeText;
      badgeElement.className = `mc-badge ${badgeClass}`;

      if (netPoints < coupon_min_amt) {
        noticeContainer.classList.remove('mc-notice-success');
        noticeText.textContent = `Earn ${needPoints} more points to unlock a discount coupon!`;
        discountBtn.style.display = 'none';
      } else {
        noticeContainer.classList.add('mc-notice-success');
        noticeText.textContent = 'You have enough points to generate a discount coupon!';
        discountBtn.style.display = 'block';
      }
      
      if (coupon_codes && coupon_codes.length > 0) {
        console.log("inside if");
        couponList.innerHTML = coupon_codes.map(coupon => `<li class="mc-coupon-item">${coupon}</li>`).join('');
        couponsContainer.style.display = 'block';
      }
      else {
        console.log("inside else");
        couponsContainer.style.display = 'none';
      }

      noData.style.display = 'none';
    } catch (error) {
      console.error('Fetch Points Error:', error);
      noData.textContent = `No coupon data for this customer`;
      noData.style.display = 'block';
      noticeContainer.style.display = 'none';
      discountBtn.style.display = 'none';
      couponsContainer.style.display = 'none';
      const badgeElement = document.getElementById('customer-badge');
      badgeElement.textContent = 'Basic';
      badgeElement.className = 'mc-badge basic';
    }
  }
async function fetchCustomerCoupons() {
  try {
    const response = await fetch(`${apiBaseUrl}/get-coupons`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({
        userId: customerId,
        shop: Shopify.shop,
      }),
    });
    const data = await response.json();
    if (!response.ok || !data.success) {
      throw new Error(data.message || 'No data found for coupon code');
    }
    const { coupon_codes } = data;
    if (coupon_codes && coupon_codes.length > 0) {
      couponList.innerHTML = coupon_codes
        .map(
          coupon => `
            <li class="mc-coupon-item">
              <span class="mc-coupon-code">${coupon.coupon_code}</span>
              <span class="mc-coupon-amount">Amount: ${coupon.amount*250}</span>
            </li>`
        )
        .join('');
      couponsContainer.style.display = 'block';
    } else {
      couponsContainer.style.display = 'none';
    }
  } catch (error) {
    console.error('Fetch Coupons Error:', error);
    couponsContainer.style.display = 'none';
  }
}
  async function fetchEarnedPoints(cursor = null, perPage = 10, direction = 'next') {
    try {
      const response = await fetch(`${apiBaseUrl}/get-orders`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({
          customer_id: customerId,
          shop: Shopify.shop,
          per_page: perPage,
          cursor: cursor,
          direction: direction,
        }),
      });

      const data = await response.json();
      if (!response.ok || !data.body?.data?.orders) {
        throw new Error(data.message || `Orders data not found for user`);
      }

      const pointsBody = document.getElementById('earned-points-body');
      const pagination = document.getElementById('earned-points-pagination').querySelector('ul');
      pointsBody.innerHTML = '';
      pagination.innerHTML = '';

      const { nodes, pageInfo } = data.body.data.orders;

      if (nodes.length === 0) {
        pointsBody.innerHTML = '<tr><td colspan="6" class="mc-no-data">No earned points available.</td></tr>';
        return;
      }

      nodes.forEach(point => {
        const row = document.createElement('tr');
        row.setAttribute('role', 'row');
        row.innerHTML = `
          <td headers="ColumnOrderId" role="cell" data-label="Order ID">${point.order_id}</td>
          <td headers="ColumnPointsGenerated" role="cell" data-label="Points Generated">${point.points_generated}</td>
          <td headers="ColumnOrderAmount" role="cell" data-label="Order Amount">${point.order_amount}</td>
          <td headers="ColumnStatus" role="cell" data-label="Status">${point.status}</td>
          <td headers="ColumnCreatedAt" role="cell" data-label="Created At">${new Date(point.created_at).toLocaleDateString()}</td>
        `;
        pointsBody.appendChild(row);
      });

      if (pageInfo.hasPreviousPage) {
        const prevLi = document.createElement('li');
        const prevCursor = cursor ? nodes[0].id : null;
        prevLi.innerHTML = `<a href="#" data-cursor="${prevCursor}" aria-label="Previous Page"><svg aria-hidden="true" focusable="false" viewBox="0 0 10 6"><path fill-rule="evenodd" clip-rule="evenodd" d="M9.354 5.354a.5.5 0 01-.708 0L5 1.707 1.354 5.354a.5.5 0 01-.708-.708l4-4a.5.5 0 01.708 0l4 4a.5.5 0 010 .708z" fill="currentColor"></path></svg></a>`;
        prevLi.addEventListener('click', (e) => {
          e.preventDefault();
          fetchEarnedPoints(prevCursor, perPage, 'previous');
        });
        pagination.appendChild(prevLi);
      }

      if (pageInfo.hasNextPage) {
        const nextLi = document.createElement('li');
        nextLi.innerHTML = `<a href="#" data-cursor="${pageInfo.endCursor}" aria-label="Next Page"><svg aria-hidden="true" focusable="false" viewBox="0 0 10 6"><path fill-rule="evenodd" clip-rule="evenodd" d="M9.354.646a.5.5 0 00-.708 0L5 4.293 1.354.646a.5.5 0 00-.708.708l4 4a.5.5 0 00.708 0l4-4a.5.5 0 000-.708z" fill="currentColor"></path></svg></a>`;
        nextLi.addEventListener('click', (e) => {
          e.preventDefault();
          fetchEarnedPoints(pageInfo.endCursor, perPage, 'next');
        });
        pagination.appendChild(nextLi);
      }
    } catch (error) {
      console.error('Fetch Error:', error);
      const pointsBody = document.getElementById('earned-points-body');
      pointsBody.innerHTML = `<tr><td colspan="6" class="mc-no-data">Error fetching earned points: ${error.message}</td></tr>`;
    }
  }

  if (generateCouponBtn) {
    generateCouponBtn.addEventListener('click', async function() {
      try {
        generateCouponBtn.disabled = true;
        generateCouponBtn.textContent = 'Generating...';
        const coupon_value = 1000*250;
        const response = await fetch(`${apiBaseUrl}/generate-coupon`, {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
          },
          body: JSON.stringify({
            couponValue: coupon_value,
            userId: customerId,
            shop: Shopify.shop,
          }),
        });

        const data = await response.json();
        if (!response.ok || !data.success) {
          throw new Error(data.message || 'Failed to generate coupon');
        }

        modalBody.innerHTML = `
          <p class="mc-modal-text mc-notice-success">Congratulations! Your Discount code is generated and you can copy it by clicking this button below:</p>
          <p class="mc-coupon-code">${data.discount.code}</p>
          <button class="mc-modal-btn mc-copy-btn">Copy Coupon Code</button>
          <button class="mc-modal-btn mc-modal-close-btn" onclick="document.getElementById('mc-coupon-modal').style.display='none'">Close</button>
        `;

        const copyBtn = modalBody.querySelector('.mc-copy-btn');
        copyBtn.addEventListener('click', function() {
          navigator.clipboard.writeText(data.discount.code).then(() => {
            copyBtn.textContent = 'Copied!';
            setTimeout(() => {
              copyBtn.textContent = 'Copy Coupon Code';
            }, 2000);
          }).catch(err => {
            console.error('Failed to copy:', err);
            modalBody.innerHTML += `<p class="mc-notice-text mc-notice-error">Failed to copy coupon code.</p>`;
          });
        });

        await fetchCustomerPoints();
      } catch (error) {
        modalBody.innerHTML = `
          <p class="mc-notice-text mc-notice-error">Error generating coupon: ${error.message}</p>
          <button class="mc-modal-btn mc-modal-close-btn" onclick="document.getElementById('mc-coupon-modal').style.display='none'">Close</button>
        `;
      } finally {
        generateCouponBtn.disabled = false;
        generateCouponBtn.textContent = 'Generate Coupon';
      }
    });
  }
  fetchCustomerPoints();
  fetchEarnedPoints();
  fetchCustomerCoupons();
});